export default "/images/technource-logo.png?751bd67105db55b7ce4fe89e561464ee";